import camelCase from 'lodash/camelCase';
import kebabCase from 'lodash/kebabCase';
import trimStart from 'lodash/trimStart';
import { Route, Routes } from 'react-router-dom';

import { RequiredStepName, StepName } from '~/core/enums';
import { allSteps } from '~/redux/slices/stepper';
import ColorPage from '~pages/ColorPage';
import DesignPage from '~pages/DesignPage';
import MaterialPage from '~pages/MaterialPage';
import OrderSummaryPage from '~pages/OrderSummaryPage';
import StorePage from '~pages/StorePage';
import Layout from '~templates/Layout';

type RouteStepValue<Step extends StepName> = {
  step: Step;
  label: string;
  path: `/${string}`;
  Component: () => JSX.Element;
};

export const mapPathToStep = (path: string): StepName | undefined => {
  const stepName = camelCase(trimStart(path, '/')) as StepName;

  return allSteps.includes(stepName) ? stepName : undefined;
};

const getPathStep = <Step extends StepName>(
  step: Step
): Pick<RouteStepValue<Step>, 'step' | 'path'> => ({
  step,
  path: `/${kebabCase(step as string)}`,
});

export const router: {
  [Step in RequiredStepName]: RouteStepValue<Step>;
} = {
  [StepName.store]: {
    step: StepName.store,
    path: '/',
    label: 'STORE',
    Component: StorePage,
  },
  [StepName.material]: {
    ...getPathStep(StepName.material),
    label: 'MATERIAL',
    Component: MaterialPage,
  },
  [StepName.color]: {
    ...getPathStep(StepName.color),
    label: 'COLOR',
    Component: ColorPage,
  },
  [StepName.designShape]: {
    ...getPathStep(StepName.designShape),
    label: 'DESIGN',
    Component: DesignPage,
  },
  [StepName.orderSummary]: {
    ...getPathStep(StepName.orderSummary),
    label: 'ORDER SUMMARY',
    Component: OrderSummaryPage,
  },
};

export const stepRoutes = [
  router.store,
  router.material,
  router.color,
  router.designShape,
  router.orderSummary,
];

const RouterDom = () => (
  <Routes>
    {stepRoutes.map((route, index) => (
      <Route key={index} path={route.path} element={<Layout />}>
        <Route index element={<route.Component />} />
      </Route>
    ))}
  </Routes>
);

export default RouterDom;
